import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContactTypeEnum, IAirlineUserContactInfo } from '@cai-services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'mart-airline-contact-popup',
  templateUrl: './airline-contact-popup.component.html',
  styleUrl: './airline-contact-popup.component.scss',
  standalone: false,
})
export class AirlineContactPopupComponent implements OnInit {
  @Input() airlineContacts: IAirlineUserContactInfo[];
  airlineContactsDisplay = [];

  constructor(
    public activeModal: NgbActiveModal,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.prepareAirlineContactsDisplay();
  }

  prepareAirlineContactsDisplay() {
    this.airlineContacts.forEach((contact) => {
      contact.contactTypes.forEach((contactType) => {
        const [contactTypeDisplay, tags] =
          this.prepareContactDisplay(contactType);
        this.airlineContactsDisplay.push({
          contactType: contactTypeDisplay,
          contactTypeTags: tags,
          contact,
        });
      });
    });

    this.airlineContactsDisplay = Array.from(
      new Map(
        this.airlineContactsDisplay
          .sort((a, b) => a.contactType.localeCompare(b.contactType))
          .map((contact) => [contact.contactType, contact]),
      ).values(),
    );
  }

  getEmail(contact: IAirlineUserContactInfo) {
    return contact.email != null ? contact.email.toLowerCase() : '-';
  }

  getPhoneNumber(contact: IAirlineUserContactInfo) {
    return contact.phoneNumber != null ? contact.phoneNumber : '-';
  }

  prepareContactDisplay(contactType) {
    let tags = [];
    switch (contactType) {
      case ContactTypeEnum.SALES:
        tags = [
          $localize`:@@compare-rate.pricing:Pricing`,
          $localize`:@@compare-rate.promotions:Promotions`,
          $localize`:@@compare-rate.contracts:Contracts`,
        ];
        return [$localize`:@@compare-rate.sales:Sales`, tags];
      case ContactTypeEnum.RESERVATION:
        tags = [
          $localize`:@@compare-rate.booking:Booking`,
          $localize`:@@compare-rate.schedules:Schedules`,
        ];
        return [$localize`:@@compare-rate.operations:Operations`, tags];
      case ContactTypeEnum.ESCALATION:
        tags = [
          $localize`:@@compare-rate.management:Management`,
          $localize`:@@compare-rate.complaints:Complaints`,
        ];
        return [$localize`:@@compare-rate.escalation:Escalation`, tags];
      case ContactTypeEnum.ACCOUNTING:
        tags = [
          $localize`:@@compare-rate.billing:Billing`,
          $localize`:@@compare-rate.payments:Payments`,
        ];
        return [$localize`:@@compare-rate.accounting:Accounting`, tags];
    }
  }

  copyToClipboard(text) {
    navigator.clipboard.writeText(text);
  }
  goToAirlineContactPage() {
    this.router.navigateByUrl('/forwarder/dashboard/airline-contacts');
  }

  closeModal() {
    this.activeModal.dismiss();
  }
}
